/**
 * 省市县选择组件-没有热门城市
 */
<template>
    <div class="region-wrap" ref="region">
        <div class="region-but" @click="onOpen()">
            <div class="input-box"><input type="text" v-model="cityName" readonly placeholder="请选择城市" /></div>
            <div class="ico-box"><img :style="{ transform: `rotate(${iconRotate})`}" src="../../../assets/images/btn_next@2x.png" /></div>
            <div class="cover-box"></div>
        </div>
        <div class="region" v-show="isShow">
            <div class="region-body">
                <div class="header">
                    <label class="title">选择城市</label>
                    <span class="close" @click="onClose"></span>
                </div>
                <div class="tab-box" ref="cityProWrap">
                    <div class="tabs" :class="[isTab ? '' : 'selected']" @click="toCity">{{provinceName || "选择省份"}}</div>
                    <div v-show="isTab" class="triangle-right"></div>
                    <div v-show="isTab" class="tabs selected">{{cityName || '选择城市'}}</div>
                </div>
                <div class="inverse-box" v-if="useGeoLocation">当前定位：
                    <span v-if="location.city_id" @click="selectedCity(location)">{{location.city_name}}</span>
                    <span v-else>定位失败</span>
                </div>
                <div class="region-transform" :style="{transform: cityStyle}">
                    <div class="listbox">
                        <div class="list">
                            <template v-for="unit in letter">
                                <div class="dd left-padding" :class="{'selected': provinceID === item.id}" @click="toProvinces(item)" v-for="(item, index) in provinceList[unit]" :key="index + unit">
                                    <span class="letter title" :style="{visibility: index !==0 ? 'hidden' : ''}">{{unit}}</span>
                                    <span class="name">{{item.name}}</span>
                                    <span class="opt" v-show="provinceID === item.id">
                                        <i class="iconfont icon-check"></i>
                                    </span>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="listbox">
                        <div class="list">
                            <template v-for="unit in letter">
                                <div class="dd left-padding" :class="{'selected': cityID === item.city_id}" @click="selectedCity(item)" v-for="(item, index) in citiyList[unit]" :key="index + unit">
                                    <span class="letter title" :style="{visibility: index !==0 ? 'hidden' : ''}">{{unit}}</span>
                                    <span class="name">{{item.city_name}}</span>
                                    <span class="opt" v-show="cityID === item.city_id">
                                        <i class="iconfont icon-check"></i>
                                    </span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg" @click="onClose"></div>
        </div>
    </div>
</template>
<script>
import makePy from '@/util/make-py';
import { stopBodyScroll } from '@/util/dom';
import { getLocation } from '@/util/platform';
import { mapActions } from 'vuex';

export default {
    props: {
        provinces: {
            type: Array,
            default: () => {
                return [];
            }
        },
        cities: {
            type: Array,
            default: () => {
                return [];
            }
        },
        clientHeight: {
            type: Number,
            default: 0
        },
        iconPosition: {
            type: String,
            default: 'bottom'
        },
        useGeoLocation: {
            type: Boolean,
            default: false
        },
        handleLocatingFailed: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            isShow: false,
            letter: 'ABCDEFGHIJKMLNOPQRSTUVWXYZ',
            arrowImg: require('@/assets/images/right_arrow.png'),
            // 选择省份name
            provinceName: '',
            provinceID: '',
            // 城市id
            cityID: '',
            cityName: '',
            // 切换样式
            cityStyle: '',
            scrollTop: 0,
            // 定位 城市
            location: {
                city_id: '',
                city_name: ''
            },
            // 选中城市
            isTab: false
        };
    },
    beforeMount() {
        if (this.useGeoLocation) {
            this.selectCityByLocation();
        }
    },
    methods: {
        ...mapActions('marketing/', ['rgeoDetail']),
        // 选择省
        toProvinces(param) {
            this.provinceName = param.name;
            this.provinceID = param.id;
            this.isTab = true;
            // 触发父级查询
            this.$emit('citiesList', param.id);
            setTimeout(() => {
                this.cityStyle = 'translate3d(-100vw, 0px, 0px)';
            }, 200);
        },
        // 返回城市
        toCity() {
            this.cityStyle = '';
            this.cityID = '';
            this.cityName = '';
            this.isTab = false;
        },
        // 确认城市
        selectedCity(param, triggerClose = true) {
            this.cityID = param.city_id;
            this.cityName = param.city_name;
            this.$emit('onConfirmRegion', param);
            if (triggerClose) {
                this.$nextTick(() => {
                    this.onClose();
                });
            }
        },
        onOpen() {
            stopBodyScroll(true);
            if (this.clientHeight !== 0) {
                window.scroll({
                    top: this.clientHeight,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            this.isShow = true;
            this.$emit('onOpen');
        },
        onClose() {
            stopBodyScroll(false);
            this.isShow = false;
        },
        // 返回首字母
        getPy(value) {
            if (value) {
                const chList = makePy(value);
                if (chList.length > 0) {
                    return chList[0].charAt(0);
                }
            }
            return ' ';
        },
        // 返回a～z顺序列表
        formatList(list) {
            const newList = [];
            for (const item of list) {
                const unit = this.getPy(item.name || item.city_name);
                const obj = {
                    first: unit,
                    ...item
                };
                newList[unit]
                    ? newList[unit].push(obj)
                    : (newList[unit] = [obj]);
            }
            return newList;
        },
        getStyle(dom, attr) {
            if (dom.currentStyle) {
                return dom.currentStyle[attr];
            } else {
                return document.defaultView.getComputedStyle(dom, null)[attr];
            }
        },
        async selectCityByLocation() {
            try {
                const { lat, lng } = await getLocation();
                // 逆向解析
                const res = await this.rgeoDetail({
                    latitude: lat,
                    longitude: lng
                });
                if (res.city && res.city_code) {
                    const { city, city_code } = res;
                    this.location = { city_id: city_code, city_name: city };
                    this.selectedCity(
                        { city_id: city_code, city_name: city },
                        false
                    );
                } else {
                    throw {
                        message: res.message || '逆地址解析失败',
                        result_code: res.result_code
                    };
                }
            } catch (e) {
                console.error('Locate Failed: ', e);
                this.location = {
                    city_id: '',
                    city_name: ''
                };
                this.handleLocatingFailed();
            }
        }
    },
    computed: {
        provinceList() {
            const list = this.provinces;
            return this.formatList(list);
        },
        citiyList() {
            const list = this.cities;
            return this.formatList(list);
        },
        iconRotate() {
            if (this.iconPosition === 'right') {
                return '-90deg';
            }
            return '0';
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.line-height(@h) {
    height: @h * @layout375;
    line-height: @h * @layout375;
}
.left-padding() {
    padding-left: 25 * @layout375;
}
.right-padding() {
    padding-right: 25 * @layout375;
}
.left-padding {
    .left-padding();
}

.region-wrap {
    width: 100%;
    .region-but {
        position: relative;
        display: flex;
        .input-box {
            flex: 1;
        }
        .ico-box {
            width: 20 * @layout375;
            margin-left: 5 * @layout375;
            text-align: right;
            display: flex;
            align-items: center;
            img {
                width: 90%;
            }
        }
        .cover-box {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 2;
            top: 0;
        }
    }
    .region {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0;
        padding: 0;
        font-size: 15px;
        z-index: 999;
        .icon-check {
            color: #00bcbc;
        }
        .region-body {
            justify-content: space-between;
            background: #fff;
            position: relative;
            height: 560 * @layout375;
            position: fixed;
            bottom: 0;
            z-index: 1001;
            .header {
                width: 100vw;
                .line-height(60);
                display: flex;
                justify-content: space-between;
                align-items: center;
                .left-padding();
                .right-padding();
                .title {
                    color: #363c54;
                    font-size: 18px;
                }
                .close {
                    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAG1BMVEVHcExpbn9ibHpqbYBqbX5mZoBpbYBobH5pbX8ZklvmAAAACHRSTlMAnBbUWQq8fwUtPhEAAACnSURBVDjL5dNNCsMgEAVghfxsC9m4zBl6iJBlyRVCDtAjFDdz7BqR8Y2+E7SuHOWDmSc69xfrjcX20u0sj3o+yKV7L596scuzFqGSQeLqGDEAiAVAGqCkBUo6UEgPCiEgEwYyoeAmFNyEg9QShuwwVgwZQQyUpJY8I3kGRvIMhJShe1KG7oim1BJNqSEQqyUQqyHmHZBMGKuHYjzxHRYoDuzk+KmP/AVZBzZ2i29QLQAAAABJRU5ErkJggg==);
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 14.5 * @layout375;
                    height: 14.5 * @layout375;
                }
            }
            .tab-box {
                display: flex;
                position: relative;
                border-bottom: 1px solid #f0f1f2;
                .line-height(40);
                .left-padding();
                .tabs {
                    font-size: 14px;
                    margin-right: 25 * @layout375;
                    color: #00bebe;
                    &.selected {
                        border-bottom: 2px solid #00bebe;
                    }
                }
            }
            .inverse-box {
                .left-padding();
                font-size: 14px;
                color: #363c54;
                border-bottom: 1px solid #f0f1f2;
                .line-height(40);
            }
            .region-transform {
                display: flex;
                transition: all 0.3s ease-in-out;
                transform: translate3d(0px, 0px, 0px);
                .listbox {
                    width: 100vw;
                    height: 420 * @layout375;
                    overflow: auto;
                    .list {
                        .flexbox(column);
                        .dd {
                            display: flex;
                            align-items: center;
                            padding-top: 25rem * @unit;
                            padding-bottom: 25rem * @unit;
                            .letter {
                                margin-right: 40rem * @unit;
                            }
                            .name {
                                flex-grow: 1;
                            }
                            .opt {
                                width: 60rem * @unit;
                            }
                            &.selected {
                                background: #f8f8f8;
                            }
                        }
                    }
                }
            }
        }
        .title {
            font-size: 14px;
            color: #999999;
            display: inline-block;
        }
        .bg {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: 1000;
            text-align: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/marketing_components/form/region-simple/index.vue